import Icon from '../components/Icon.vue'

Icon.register({"window-restore":{"width":512,"height":512,"paths":[{"d":"M512 48V336C512 362.5 490.5 384 464 384H416V176C416 131.9 380.1 96 336 96H128V48C128 21.5 149.5 0 176 0H464C490.5 0 512 21.5 512 48zM384 176V464C384 490.5 362.5 512 336 512H48C21.5 512 0 490.5 0 464V176C0 149.5 21.5 128 48 128H336C362.5 128 384 149.5 384 176zM316 204C316 197.4 310.6 192 304 192H76C69.4 192 64 197.4 64 204V256H316V204z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/window-restore.js
// module id = PaU0
// module chunks = 0